import React, { useState } from "react";
import { Font } from "@react-pdf/renderer";
import logo from "../../assests/AGP_Logo.png";
import { addLeadingZeros } from "../../utils/DataUtils";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  pdf,
} from "@react-pdf/renderer";

const InvoiceEtiquetas = async (invoice) => {
  const pdfBlob = await pdf(<MyDocument data={invoice} />).toBlob();

  const url = URL.createObjectURL(pdfBlob);

  window.open(url, "_blank").print();

  URL.revokeObjectURL(url);
};

Font.register({
  family: "Open Sans",
  fonts: [
    {
      src: "https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf",
    },
    {
      src: "https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-700.ttf",
      fontWeight: "bold",
    },
  ],
});
const styles = StyleSheet.create({
  text: {
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "Open Sans",
  },

  page: {
    padding: 22,
  },
});

const MyDocument = ({ data }) => {
  return (
    <Document>
      {data.map((etiqueta, index) => (
        <Page size="B7" orientation="landscape" style={styles.page}>
          <Text key={index}  style={{ fontSize: 12 }}>
            {`Ref Lote: EXP${addLeadingZeros(etiqueta.id, 6)}`}
          </Text>
          <View style={{ display: "flex" }}>
            <Text
              key={index}
              style={{ fontSize: 10 }}
            >{`Veiculo: ${etiqueta.descricaoMaterial}`}</Text>
            <Text
              key={index}
              style={{ fontSize: 10 }}
            >{`Peça: ${etiqueta.peca}`}</Text>
          </View>
        </Page>
      ))}
    </Document>
  );
};

export default InvoiceEtiquetas;
